import React, { Fragment } from "react";
import moment from "moment";
import anchorme from "anchorme";

import "./ChatWidgetMainView.css";
import ChatWidgetMainViewChatField from "./ChatWidgetMainViewChatField";
import { ChatMessageType, MessageSenderType, PostMessageType, MediaType } from "../../constants";
import Loader from "../../component/Loader/Loader";
import PostMessageContext from "../../context/PostMessageContext";
import { AngleDownDouble, CrossWhite, File } from "../../assets/Svg-icons";
import { User } from "../../assets/images";
import { validateEmail } from "../../utils/validateUtils";
import { concatBaseMediaUrl } from "../../utils/imageUtils";
import Logo from "../../assets/Svg-icons/SSLogo/PoweredBySSLogo.svg";
import DefaultAvatar from "../../assets/images/bot-avatar.png";
import SuccessCheck from "../../assets/images/check-circle.png";
import EmailModalCross from "../../assets/Svg-icons/Cross/EmailModalCross.svg";

class ChatWidgetMainViewContent extends React.Component {
    constructor() {
        super();
        this.state = {
            FirstName: "",
            Email: "",
            Message: "",
            PhoneNumber: "",
            emailError: false,
            isLoading: false,
            file: null,
            imagePreview: null,
            fileType: null,
            imageUploading: false,
            isAgentJoined: true,
            currentSelectedChat: null,
            currentReadChatIndex: null
        };
        this.isAbove = false;
        this.ChatFieldRef = React.createRef();
    }

    componentDidMount() {
        document
            .getElementById("email-modal-animated")
            .addEventListener("animationend", this.onContainerAnimationEnd);
        document.getElementById("email-modal").classList.add("hide");
    }

    getSnapshotBeforeUpdate() {
        const container = document.getElementById("swiftchat-scroll-div");
        return { prevScrollHeight: container.scrollHeight, prevScrollTop: container.scrollTop };
    }

    componentDidUpdate(prevProps, prevState, { prevScrollHeight, prevScrollTop }) {
        if (prevState.currentReadChatIndex === this.state.currentReadChatIndex) {
        }
        if (!this.props.isNewMessage) {
            const container = document.getElementById("swiftchat-scroll-div");
            container.scrollTop = container.scrollHeight - (prevScrollHeight - prevScrollTop);
        }
        if (this.props.agentJoined && this.state.isAgentJoined) {
            this.handleMoveDownClick();
            this.setState({ isAgentJoined: false });
        }
        if (this.props.showOptionsContainer) {
            document.getElementById("email-modal").classList.remove("hide");
        }
    }

    componentWillUnmount() {
        document
            .getElementById("email-modal-animated")
            .removeEventListener("animationend", this.onContainerAnimationEnd);
    }

    handleInputChange = (e) => {
        let name = e.target.dataset.name;
        this.setState({ [name]: e.target.value, emailError: false });
    };

    onContainerAnimationEnd = () => {
        if (!this.props.showOptionsContainer) {
            document.getElementById("email-modal").classList.add("hide");
        }
    };

    convertTimestampToDate(time, index) {
        const { messageDataAvailable } = this.props;
        const { widgetSettings } = this.context;

        let previousMessage = this.props.messageData[index - 1];
        let date;
        let showDate = true;

        if (
            previousMessage &&
            previousMessage.Data.EventType === ChatMessageType.Message &&
            previousMessage.Data.CreatedAt
        ) {
            let isPreviousDay = moment(previousMessage.Data.CreatedAt).isBefore(time, "day");
            let isSameMinute = moment(previousMessage.Data.CreatedAt).isSame(time, "minute");
            if (isSameMinute) {
                showDate = false;
            }
            if (isPreviousDay) {
                date = moment(time).format("LLL");
            }
        } else {
            if (!messageDataAvailable) {
                date = moment(time).format("LLL");
            }
        }

        if (!date) {
            date = moment(time).format("LT");
        }
        return showDate ? (
            <div className="reply-date" style={{ color: widgetSettings.Appearance.LabelTextColor }}>
                {date}
            </div>
        ) : null;
    }

    handleContainerSubmit = (e) => {
        e.preventDefault();
        if (this.props.showEmailContainer) {
            const { Email } = this.state;
            if (!validateEmail(Email)) {
                this.setState({ emailError: true });
                return;
            }
            this.props.onEmailChatClick(Email);
            this.setState({ Email: "" });
        } else if (this.props.showEndConversationContainer) {
            this.props.onEndConversationClick();
        } else {
            this.props.handleContainerCancelClick();
        }
    };

    handleFormSubmit = (e) => {
        e.preventDefault();
        const { FirstName, Email, Message, PhoneNumber } = this.state;

        if (!validateEmail(Email)) {
            this.setState({ emailError: true });
            return;
        }
        let data = { FirstName, Email, Message, Phone: PhoneNumber };
        this.setState({ isLoading: true });
        this.context.IframePostMessage({ Message: PostMessageType.SubmitForm, Data: data });
    };

    handleScroll = (e) => {
        const { messageLoading } = this.props;

        const isTop = e.target.scrollTop < 100;
        const aboveBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight > 80;
        if (isTop && !messageLoading) {
            this.context.IframePostMessage({
                Message: PostMessageType.LoadMoreMessages,
                Data: true
            });
        }
        if (aboveBottom && !this.isAbove) {
            this.props.changeDownButtonState(true);
            this.isAbove = true;
        } else if (!aboveBottom && this.isAbove) {
            this.props.changeDownButtonState(false);
            this.props.changeUnseenMessagesCount(0);
            this.isAbove = false;
        }
    };

    handleMoveDownClick = () => {
        let container = document.getElementById("swiftchat-scroll-div");
        let scrollTop = container.scrollHeight;
        container.scroll({
            top: scrollTop
        });
        this.props.changeUnseenMessagesCount(0);
    };

    onFileChange = (data = {}) => {
        this.setState({ ...data });
    };

    handleImageClearClick = () => {
        this.setState({ fileType: null, file: null, imagePreview: null });
        this.ChatFieldRef.current.clearSelectedFile();
    };

    renderOptionsContainer = () => {
        const {
            handleContainerCancelClick,
            showEmailContainer,
            showOptionsContainer,
            showEndConversationContainer,
            showEmailSuccessMessage,
            resolveChatWidget
        } = this.props;
        const { widgetSettings } = this.context;
        return (
            <form onSubmit={this.handleContainerSubmit}>
                <div
                    className={`email-modal-backrop fixed animated faster ${
                        !showOptionsContainer ? "fadeOut" : "fadeIn"
                    }`}
                    id="email-modal"
                >
                    <div
                        className={`email-modal transcript-email-form ${
                            showOptionsContainer ? "fadeInUp" : "fadeOutDown"
                        } animated faster`}
                        id="email-modal-animated"
                    >
                        <div className="email-modal-content-wrapper email-chat-message-modal">
                            {showEmailContainer && (
                                <div className="cancel-email-modal">
                                    <img
                                        onClick={handleContainerCancelClick}
                                        src={EmailModalCross}
                                        alt="Cancel"
                                    />
                                </div>
                            )}
                            <div className="email-modal-content transcript-form">
                                {showEmailSuccessMessage && (
                                    <div className="image-wrapper">
                                        <img src={SuccessCheck} alt="Success" />
                                    </div>
                                )}
                                <h1>
                                    {showEmailContainer
                                        ? "Enter your email address to receive this chat"
                                        : showEndConversationContainer
                                        ? "Would you like to end this conversation?"
                                        : "Conversation has been sent to your provided email"}
                                </h1>
                                {showEmailContainer && (
                                    <div className="email-modal-input transcript-form-input">
                                        <input
                                            className={this.state.emailError ? "error" : ""}
                                            type="email"
                                            placeholder="Email"
                                            data-name="Email"
                                            onChange={this.handleInputChange}
                                            value={this.state.Email}
                                            required
                                        />
                                    </div>
                                )}
                                <div
                                    className={`email-modal-btn-wrapper ${widgetSettings.Behaviour
                                        .BrandingEnabled &&
                                        "email-modal-btn-wrapper-branding-enable"}`}
                                >
                                    <button
                                        type="submit"
                                        className="btn email-btn send"
                                        onClick={() => {
                                            !showEmailContainer && resolveChatWidget();
                                        }}
                                        style={{
                                            backgroundColor:
                                                widgetSettings.Appearance.TitleBarColor,
                                            border: widgetSettings.Appearance.TitleBarColor
                                        }}
                                    >
                                        {showEmailContainer ? "Send" : "Done"}
                                    </button>
                                    {/* {!showEmailSuccessMessage && (
                                        <button
                                            className="btn email-btn cancel"
                                            onClick={handleContainerCancelClick}
                                        >
                                            Cancel
                                        </button>
                                    )} */}
                                    {widgetSettings.Behaviour.BrandingEnabled && (
                                        <div className="email-modal-footer">
                                            <p>Powered by </p> &nbsp;
                                            <a
                                                href="https://www.swiftsales.io/"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <img src={Logo} alt="logo" />
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    };

    renderEmailForm = () => {
        const { FirstName, Email, Message, isLoading, PhoneNumber } = this.state;
        const { currentlyActiveAgents } = this.props;
        const { widgetSettings } = this.context;
        return (
            <form onSubmit={this.handleFormSubmit}>
                <div className="email-modal-backrop email-form">
                    <div className="email-modal email-form fancy-scroll auto">
                        {/* <div className="email-form-message">Offline</div> */}
                        <div className="email-modal-content-wrapper">
                            <div
                                className="email-modal-content"
                                style={
                                    {
                                        // borderColor: widgetSettings.Appearance.TitleBarColor
                                    }
                                }
                            >
                                {!widgetSettings.Behaviour.PreChatFormEnabled &&
                                    currentlyActiveAgents &&
                                    widgetSettings.Behaviour.OfflineFormEnabled && (
                                        <h2>
                                            All agents are busy. We will get back to you. Meanwhile,
                                            fill this form
                                        </h2>
                                    )}
                                <div className="email-modal-input">
                                    <input
                                        type="text"
                                        placeholder="Name"
                                        data-name="FirstName"
                                        required
                                        maxLength="100"
                                        onChange={this.handleInputChange}
                                        value={FirstName}
                                    />
                                </div>
                                <div className="email-modal-input">
                                    <input
                                        className={this.state.emailError ? "error" : ""}
                                        type="email"
                                        placeholder="Email"
                                        data-name="Email"
                                        required
                                        onChange={this.handleInputChange}
                                        value={Email}
                                    />
                                </div>
                                <div className="email-modal-input">
                                    <input
                                        className={
                                            this.state.emailError
                                                ? "error number-to-text"
                                                : "number-to-text"
                                        }
                                        type="number"
                                        placeholder="Phone (Optional)"
                                        data-name="PhoneNumber"
                                        // required
                                        onChange={this.handleInputChange}
                                        value={PhoneNumber}
                                    />
                                </div>
                                <div className="email-modal-input">
                                    <textarea
                                        rows="6"
                                        type="text"
                                        required
                                        maxLength={1000}
                                        data-name="Message"
                                        placeholder="Message"
                                        onChange={this.handleInputChange}
                                        value={Message}
                                    />
                                </div>
                                <div className={`email-modal-btn-wrapper`}>
                                    <button
                                        className="btn email-btn send"
                                        type="submit"
                                        style={{
                                            backgroundColor:
                                                widgetSettings.Appearance.TitleBarColor,
                                            border: widgetSettings.Appearance.TitleBarColor
                                        }}
                                    >
                                        {isLoading && <Loader color="gray" />}
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                        {widgetSettings.Behaviour.BrandingEnabled && (
                            <div className="email-modal-footer">
                                <p>Powered by </p> &nbsp;
                                <a
                                    href="https://www.swiftsales.io/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <img src={Logo} alt="logo" />
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </form>
        );
    };

    renderMessageContent = (msgData, isAgent = false) => {
        const { widgetSettings } = this.context;
        const messageColor = isAgent
            ? widgetSettings.Appearance.AgentMessageTextColor
            : widgetSettings.Appearance.VisitorMessageTextColor;

        if (!!msgData.Attachment) {
            let url = concatBaseMediaUrl(msgData.Attachment.Path);
            if (msgData.Attachment.MediaType === MediaType.IMAGE) {
                return (
                    <div>
                        <a href={url} target="_blank" rel="noopener noreferrer">
                            <img
                                onLoad={() => {
                                    !this.props.showDownButton && this.handleMoveDownClick();
                                }}
                                src={url}
                                onClick={() => {
                                    window.open(url);
                                }}
                                alt="attachment"
                                className="chat-message-image"
                            />
                        </a>
                        {msgData.Content && <p className="message-caption">{msgData.Content}</p>}
                    </div>
                );
            } else if (msgData.Attachment.MediaType === MediaType.DOCUMENT) {
                return (
                    <div>
                        <div className="chat-message-attachment">
                            <img src={File} alt="document-attachment" />
                            <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: messageColor }}
                            >
                                {msgData.Attachment.Meta ? msgData.Attachment.Meta.Name : "File"}
                            </a>
                        </div>
                        {msgData.Content && <div>{msgData.Content}</div>}
                    </div>
                );
            }
        } else {
            return typeof msgData.Content === "string" ? (
                <div
                    dangerouslySetInnerHTML={{
                        __html: this.replaceUrlWithHtmlTags(msgData.Content)
                    }}
                />
            ) : (
                msgData.Content
            );
        }
    };

    replaceUrlWithHtmlTags = (content) => {
        return anchorme(content, {
            attributes: [{ name: "target", value: "blank" }]
        });
    };

    renderReadReceipt = (msgData, index) => {
        const { chatData } = this.props;
        // const { chatData, agentData } = this.props;
        // let name = agentData.Name || "Agent";
        // let image = agentData.imageUrl || User;
        let msgId = msgData.ChatEventId || msgData.Id;
        if (chatData && chatData.AssignedAgentId) {
            let assignedAgentReceipt = chatData.ReadBy.find(
                (receipt) => receipt.Id === chatData.AssignedAgentId
            );
            if (assignedAgentReceipt && assignedAgentReceipt.ChatEventId === msgId) {
                if (this.state.currentReadChatIndex !== index) {
                    this.setState({ currentReadChatIndex: index });
                }
                return true;
            } else {
                return false;
            }
        }
        return null;
    };

    handleAvatarImage = (chatData) => {
        const { agentData, botAvatar } = this.props;

        if (chatData.SenderType === MessageSenderType.Agent) {
            return (
                <div className="avatar-wrapper">
                    {chatData.SenderType === MessageSenderType.Agent ? (
                        <img className="avatar" src={agentData.imageUrl} alt="BotAvatar" />
                    ) : (
                        <img className="BotAvatar" src={User} alt="" />
                    )}
                </div>
            );
        } else {
            return (
                <div className="avatar-wrapper">
                    {chatData.SenderType === MessageSenderType.System && botAvatar ? (
                        <img className="avatar" src={botAvatar} alt="BotAvatar" />
                    ) : (
                        <img className="avatar" src={DefaultAvatar} alt="BotAvatar" />
                    )}
                </div>
            );
        }
    };

    handleSelectedMessage = (msgKey) => {
        let { currentSelectedChat } = this.state;
        if (currentSelectedChat === msgKey) {
            this.setState({ currentSelectedChat: null });
        } else {
            this.setState({ currentSelectedChat: msgKey });
        }
    };

    renderMessage() {
        // const { messageData, chatData } = this.props;
        const { messageData } = this.props;

        const { widgetSettings } = this.context;
        let msg = messageData.map((item, index) => {
            const uniqueKey = index;
            let content;
            const imageMessage =
                item.Data.Attachment && item.Data.Attachment.MediaType === MediaType.IMAGE;
            const imageClass = imageMessage ? "image" : "";
            if (item.Data.EventType === ChatMessageType.ChatStarted) {
                content = (
                    <Fragment>
                        <div
                            className="reply-note"
                            style={{ color: widgetSettings.Appearance.LabelTextColor }}
                        >
                            <span className="dot"></span>{" "}
                            <span className="margin-x"> Chat Started </span>{" "}
                            <span className="dot"></span>
                        </div>
                    </Fragment>
                );
            } else if (item.Data.EventType === ChatMessageType.AgentJoined) {
                content = (
                    <Fragment>
                        <div
                            className="reply-note"
                            style={{ color: widgetSettings.Appearance.LabelTextColor }}
                        >
                            <span className="dot"></span>{" "}
                            <span className="margin-x"> {item.Data.firstName} joined the chat</span>{" "}
                            <span className="dot"></span>
                        </div>
                    </Fragment>
                );
            } else if (item.Data.EventType === ChatMessageType.ChatResolved) {
                content = (
                    <Fragment>
                        <div
                            className="reply-note"
                            style={{ color: widgetSettings.Appearance.LabelTextColor }}
                        >
                            <span className="dot"></span>{" "}
                            <span className="margin-x"> Chat has been resolved </span>{" "}
                            <span className="dot"></span>
                        </div>
                    </Fragment>
                );
            } else if (item.Data.EventType === ChatMessageType.Message) {
                if (item.Data.SenderType === MessageSenderType.Visitor) {
                    let { currentSelectedChat } = this.state;
                    content = (
                        <Fragment>
                            {/* {this.convertTimestampToDate(item.Data.CreatedAt, index)} */}
                            <div
                                onClick={() => this.handleSelectedMessage(item.Data.PrimaryKey)}
                                className="reply-wrapper"
                            >
                                <div className="user reply-content">
                                    <div
                                        className={`visitor-info ${currentSelectedChat ===
                                            item.Data.PrimaryKey && `animate-visitor-info`}`}
                                    >
                                        <span className="message-date-format">
                                            {moment(item.Data.CreatedAt).format(
                                                "MMM Do YYYY, h:mma"
                                            )}
                                        </span>
                                    </div>
                                    <div
                                        className={`chat-message animated fadeIn ${imageClass} ${currentSelectedChat ===
                                            item.Data.PrimaryKey && `animate-message-content`}`}
                                        style={{
                                            backgroundColor:
                                                widgetSettings.Appearance.VisitorMessageColor,
                                            // "#E8E8E8",
                                            color: widgetSettings.Appearance.VisitorMessageTextColor
                                            // color: "black"
                                        }}
                                    >
                                        {this.renderMessageContent(item.Data)}
                                    </div>
                                    {(this.renderReadReceipt(item.Data, index) ||
                                        this.state.currentReadChatIndex > index) && (
                                        <div
                                            className={`message-read-block ${currentSelectedChat ===
                                                item.Data.PrimaryKey && `animate-message-content`}`}
                                            style={{ textAlign: "right", display: "block" }}
                                        >
                                            <img
                                                src={require("../../assets/images/double-check.png")}
                                                className="read-icon"
                                                alt="Read"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Fragment>
                    );
                } else if (
                    [MessageSenderType.Agent, MessageSenderType.System].includes(
                        item.Data.SenderType
                    )
                ) {
                    let { currentSelectedChat } = this.state;
                    content = (
                        <Fragment>
                            {/* {this.convertTimestampToDate(item.Data.CreatedAt, index)} */}
                            <div className="reply-wrapper">
                                <div className="user-info-wrapper">
                                    {this.handleAvatarImage(item.Data)}
                                    {/* <div
                                        className="user-name"
                                        style={{ color: widgetSettings.Appearance.LabelTextColor }}
                                        >
                                        {item.Data.firstName}
                                    </div> */}
                                </div>
                                <div
                                    onClick={() => this.handleSelectedMessage(item.Data.PrimaryKey)}
                                    className="admin reply-content reply-animate-container"
                                >
                                    {/* {currentSelectedChat == item.Data.PrimaryKey } */}
                                    <div
                                        className={`message-sender-info ${currentSelectedChat ===
                                            item.Data.PrimaryKey && `animate-message-sender-info`}`}
                                    >
                                        {item.Data.firstName}&nbsp; • &nbsp;
                                        <span className="message-date-format">
                                            {moment(item.Data.CreatedAt).format(
                                                "MMM Do YYYY, h:mma"
                                            )}
                                        </span>
                                    </div>
                                    <div
                                        className={`chat-message animated fadeIn ${imageClass} ${currentSelectedChat ===
                                            item.Data.PrimaryKey && `animate-message-content`}`}
                                        style={{
                                            backgroundColor:
                                                widgetSettings.Appearance.AgentMessageColor,
                                            // "White",
                                            color: widgetSettings.Appearance.AgentMessageTextColor
                                        }}
                                    >
                                        {this.renderMessageContent(item.Data, true)}
                                    </div>
                                    {this.renderReadReceipt(item.Data, index)}
                                </div>
                            </div>
                        </Fragment>
                    );
                }
            }
            return (
                <div key={uniqueKey} className="reply">
                    {content}
                    {/* {chatData.Id ? this.renderReadReceipt(item.Data) : null} */}
                </div>
            );
        });

        return <div>{msg}</div>;
    }

    renderTypingHint() {
        const { widgetSettings } = this.context;
        return (
            <div className="reply typing-event">
                <div className="reply-wrapper">
                    <div className="admin reply-content render-typing-event">
                        <div
                            className="chat-message"
                            style={{
                                // backgroundColor: widgetSettings.Appearance.AgentMessageColor
                                backgroundColor: "white"
                            }}
                        >
                            <div className="typing-animation">
                                <span
                                    className="dot"
                                    style={{
                                        backgroundColor:
                                            widgetSettings.Appearance.AgentMessageTextColor
                                    }}
                                ></span>
                                <span
                                    className="dot"
                                    style={{
                                        backgroundColor:
                                            widgetSettings.Appearance.AgentMessageTextColor
                                    }}
                                ></span>
                                <span
                                    className="dot"
                                    style={{
                                        backgroundColor:
                                            widgetSettings.Appearance.AgentMessageTextColor
                                    }}
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderUploadedFile = () => {
        const { file, fileType, imagePreview, imageUploading } = this.state;
        let fileUI = null;

        if (file && fileType) {
            switch (fileType) {
                case MediaType.IMAGE:
                    fileUI = (
                        <div className="image-preview-container">
                            <img
                                className="cross-icon"
                                src={CrossWhite}
                                alt="cross-icon"
                                onClick={this.handleImageClearClick}
                            />

                            <div
                                style={{
                                    background: "#fff",
                                    padding: "2px",
                                    width: "100%",
                                    height: "100%"
                                }}
                            >
                                {!imageUploading ? (
                                    <img
                                        className="image-preview"
                                        src={imagePreview}
                                        alt="uploaded-preview"
                                    />
                                ) : (
                                    <Loader color="gray" />
                                )}
                            </div>
                        </div>
                    );
                    break;
                case MediaType.DOCUMENT:
                    fileUI = (
                        <div className="image-preview-container file">
                            <div className="file-preview" title={file.name}>
                                <img
                                    className="cross-icon file"
                                    src={CrossWhite}
                                    alt="cross-icon"
                                    onClick={this.handleImageClearClick}
                                />
                                {!imageUploading ? (
                                    <>
                                        <img
                                            className="image-preview file"
                                            src={File}
                                            alt="file-icon"
                                        />
                                        <div className="file-name">{file.name}</div>
                                    </>
                                ) : (
                                    <Loader color="gray" />
                                )}
                            </div>
                        </div>
                    );
                    break;
                case MediaType.UNSUPPORTED:
                    fileUI = (
                        <div className="image-preview-container file">
                            <div className="file-preview" title={"invalid file"}>
                                <img
                                    className="cross-icon file"
                                    src={CrossWhite}
                                    alt="cross-icon"
                                    onClick={this.handleImageClearClick}
                                />
                                {!imageUploading ? (
                                    <>
                                        <img
                                            className="image-preview file"
                                            src={File}
                                            alt="file-icon"
                                        />
                                        <div className="file-name">{"invalid file"}</div>
                                    </>
                                ) : (
                                    <Loader color="gray" />
                                )}
                            </div>
                        </div>
                    );
                    break;
                default:
                    return null;
            }
        }
        return fileUI;
    };

    render() {
        const {
            emailForm,
            messageData,
            typing,
            messageLoading,
            showDownButton,
            unseenMessages,
            chatResolved,
            // agentsOffline,
            agentJoined,
            isBotEnable,
            isAgentOffline
            // isTriggeredMessagesSet
        } = this.props;
        const { widgetSettings } = this.context;
        return (
            <div
                className="chat-content"
                // style={
                //     (agentJoined && widgetSettings.Behaviour.BrandingEnabled) ? { height: "calc(100% - 12rem)" } : (agentJoined && !widgetSettings.Behaviour.BrandingEnabled) ? { height: "calc(100% - 9rem)" } :(!agentJoined && !widgetSettings.Behaviour.BrandingEnabled) ? { height: "calc(100% - 3rem)" } : { height: "calc(100% - 6rem)" }
                // }
                style={
                    !widgetSettings.Behaviour.BrandingEnabled
                        ? agentJoined || isBotEnable
                            ? { height: "calc(100% - 10rem)" }
                            : { height: "calc(100% - 3rem)" }
                        : emailForm
                        ? widgetSettings.Behaviour.PreChatFormEnabled ||
                          (!widgetSettings.Behaviour.ChatBotEnabled &&
                              widgetSettings.Behaviour.OfflineFormEnabled)
                            ? { height: "calc(100% - 5rem)" }
                            : { height: "calc(100% - 11rem)" }
                        : agentJoined || isBotEnable
                        ? { height: "calc(100% - 11rem)" }
                        : { height: "calc(100% - 5rem)" }
                }
            >
                <div
                    className={`conversation fancy-scroll ${
                        agentJoined || isBotEnable
                            ? widgetSettings.Behaviour.BrandingEnabled
                                ? "adjust-admin-card-with-branding"
                                : `adjust-admin-card`
                            : widgetSettings.Behaviour.BrandingEnabled
                            ? "adjust-chat-content"
                            : "adjust-chat-content-disabled-widget"
                    }`}
                    // style={{ backgroundColor: widgetSettings.Appearance.BackgroundColor }}
                    style={{ background: "#F6F6F7" }}
                    id="swiftchat-scroll-div"
                    onScroll={this.handleScroll}
                >
                    {messageLoading && messageData.length > 0 ? (
                        <div className="message-loading-top">
                            <Loader size="sm" color="gray" />
                        </div>
                    ) : null}
                    {/* render chat message content */}
                    <div className="conversation-wrapper">
                        {messageData.length > 0 ? this.renderMessage() : null}
                        {/* typing */}
                        {typing ? this.renderTypingHint() : null}
                    </div>
                    {messageLoading && !messageData.length ? (
                        <div className="message-loading">
                            <Loader color="gray" />
                        </div>
                    ) : null}
                    {this.renderOptionsContainer()}
                    {showDownButton && (
                        <div
                            className={`conversation-end-btn animated fadeIn ${
                                widgetSettings.Behaviour.BrandingEnabled ? "branding-enabled" : ""
                            }`}
                            onClick={this.handleMoveDownClick}
                        >
                            <img src={AngleDownDouble} alt="angle-down-icon" />
                            {!!unseenMessages && (
                                <span
                                    className="text"
                                    style={{
                                        backgroundColor: widgetSettings.Appearance.TitleBarColor
                                    }}
                                >
                                    {unseenMessages}
                                </span>
                            )}
                        </div>
                    )}
                    {/* Img Preview */}
                    {this.renderUploadedFile()}
                </div>
                {/* emailForm */}
                {/* && !isTriggeredMessagesSet  */}
                {emailForm &&
                !messageLoading &&
                (widgetSettings.Behaviour.PreChatFormEnabled ||
                    (!widgetSettings.Behaviour.ChatBotEnabled &&
                        widgetSettings.Behaviour.OfflineFormEnabled))
                    ? this.renderEmailForm()
                    : null}
                {/* {emailForm ? this.renderEmailForm() : null} */}
                {/* !agentsOffline && */}
                {(agentJoined || widgetSettings.Behaviour.ChatBotEnabled) &&
                !chatResolved &&
                !messageLoading ? (
                    <>
                        <ChatWidgetMainViewChatField
                            ref={this.ChatFieldRef}
                            onFileChange={this.onFileChange}
                            handleImageClearClick={this.handleImageClearClick}
                        />
                        {widgetSettings.Behaviour.BrandingEnabled && (
                            <div className="email-modal-footer">
                                <p>Powered by </p> &nbsp;
                                <a
                                    href="https://www.swiftsales.io/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <img src={Logo} alt="logo" />
                                </a>
                            </div>
                        )}
                    </>
                ) : !agentJoined && widgetSettings.Behaviour.ChatBotEnabled && !chatResolved ? (
                    <>
                        <ChatWidgetMainViewChatField
                            ref={this.ChatFieldRef}
                            onFileChange={this.onFileChange}
                            handleImageClearClick={this.handleImageClearClick}
                        />
                        {widgetSettings.Behaviour.BrandingEnabled && (
                            <div className="email-modal-footer">
                                <p>Powered by </p> &nbsp;
                                <a
                                    href="https://www.swiftsales.io/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <img src={Logo} alt="logo" />
                                </a>
                            </div>
                        )}
                    </>
                ) : !agentJoined && !widgetSettings.Behaviour.ChatBotEnabled && !isAgentOffline ? (
                    <>
                        <ChatWidgetMainViewChatField
                            ref={this.ChatFieldRef}
                            onFileChange={this.onFileChange}
                            handleImageClearClick={this.handleImageClearClick}
                        />
                        {widgetSettings.Behaviour.BrandingEnabled && (
                            <div className="email-modal-footer">
                                <p>Powered by </p> &nbsp;
                                <a
                                    href="https://www.swiftsales.io/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <img src={Logo} alt="logo" />
                                </a>
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <div className="agent-bottom-message">
                            {/* agentsOffline, isAgentOffline  && */}
                            {isAgentOffline &&
                            !messageLoading &&
                            (!agentJoined ||
                                (widgetSettings.Behaviour &&
                                    !widgetSettings.Behaviour.ChatBotEnabled)) ? (
                                <p>
                                    Currently all our agents are offline, we will contact you back
                                    on the provided contact info
                                </p>
                            ) : (
                                chatResolved && (
                                    <>
                                        <p>Current Chat is Resolved by Agent</p>
                                        <button
                                            className="btn btn-chat-start"
                                            onClick={this.props.handleChatStartClick}
                                            style={{
                                                backgroundColor:
                                                    widgetSettings.Appearance.TitleBarColor,
                                                border: widgetSettings.Appearance.TitleBarColor
                                            }}
                                        >
                                            Begin Chat
                                        </button>
                                    </>
                                )
                            )}
                        </div>
                        {widgetSettings.Behaviour.BrandingEnabled && (
                            <div className="email-modal-footer">
                                <p>Powered by </p> &nbsp;
                                <a
                                    href="https://www.swiftsales.io/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <img src={Logo} alt="logo" />
                                </a>
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }
}

ChatWidgetMainViewContent.contextType = PostMessageContext;

export default ChatWidgetMainViewContent;

